/* eslint-disable @typescript-eslint/only-throw-error */
import { type LoaderFunction, redirect } from 'react-router'
import { firstValueFrom } from 'rxjs'
import { links } from '@/utils/link'
import type { CreatePayoutsRoutesOptions } from './routes'

/**
 * Creates a loader function for the pro payouts view that redirects to the
 * welcome page when the user isn't a pro.
 *
 * @param options
 */
export function createProPayoutsViewLoader(
  options: CreatePayoutsRoutesOptions,
): LoaderFunction {
  return async ({ request }) => {
    await options.waitForAuthResolution(request.signal)
    const { canViewProPayouts$ } = await options.payouts.internal()
    if (!(await firstValueFrom(canViewProPayouts$))) {
      throw redirect(links.welcome())
    }

    return null
  }
}
